import { ReactComponent } from './crowdfunding-xs.svg';

export const CrowdfundingIconXs = ReactComponent;

export default ReactComponent;
